// src/components/common/ConfirmModal.jsx
import { X } from 'lucide-react';
import Button from '../layout/ui/Button';

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title = "Are you sure?",
  message = "This action cannot be undone.",
  confirmText = "Yes, Continue",
  cancelText = "Cancel",
  danger = false,
  loading = false,
}) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-6">
          <h2 className={`text-2xl font-bold ${danger ? 'text-red-600' : 'text-gray-900'}`}>
            {title}
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-xl transition"
          >
            <X size={24} />
          </button>
        </div>

        <p className="text-lg text-gray-700 leading-relaxed">{message}</p>

        <div className="flex gap-4 mt-8">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={loading}
            className="flex-1"
          >
            {cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            isLoading={loading}
            className={`flex-1 ${danger
              ? 'bg-red-600 hover:bg-red-700 text-white'
              : 'bg-primary hover:bg-primary/90 text-white'
              } font-bold`}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
}